import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { WINDOW } from '@upr-web-primer/window';

class LockScrollService {
    constructor(document, window, renderer) {
        this.document = document;
        this.window = window;
        this.renderer = renderer;
        this._document = this.document;
        this._window = this.window;
        this._renderer = this.renderer.createRenderer(null, null);
    }
    lockScroll(element, style) {
        this._renderer.setStyle(element ? element : this._document.body, style ? style : 'overflow', 'hidden');
        if (this._window.innerWidth < 768) {
            this.scrollPos = this._window.scrollY;
        }
    }
    unlockScroll(element, style) {
        this._renderer.removeStyle(element ? element : this._document.body, style ? style : 'overflow');
        if (this._window.innerWidth < 768) {
            this._window.scrollTo(0, this.scrollPos);
        }
    }
}
LockScrollService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LockScrollService, deps: [{ token: DOCUMENT }, { token: WINDOW }, { token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable });
LockScrollService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LockScrollService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LockScrollService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i0.RendererFactory2 }]; } });

class LockScrollModule {
}
LockScrollModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LockScrollModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LockScrollModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LockScrollModule });
LockScrollModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LockScrollModule, providers: [LockScrollService] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LockScrollModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [LockScrollService]
                }]
        }] });

export { LockScrollModule, LockScrollService };
